import React from 'react';

import NebulaImg from '@images/projects/blast-galaxy/nebula.svg';

export const Nebula = props => {
    const { className } = props;
    return <NebulaImg className={className} />;
};
